var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import imageAshaLogo from '../assets/images/asha_logo.webp';
export var AshaLogo = function () {
    return (_jsx("div", __assign({ className: "flex" }, { children: _jsx("img", { src: imageAshaLogo, alt: "American Speech-Language-Hearing Association", height: "35", width: "89" }) })));
};
